<template>
  <div>
    <div class="article-block d-column">
      <div class="article-list">
        <div class="module j-flex weight">
          <div v-if="currPrograma != ''" class="fs-xl module-title">
            {{ currPrograma }}
          </div>
          <div v-else class="fs-xl module-title">
            {{ title }}
          </div>
        </div>
      </div>
      <div>
        <div class="person">
          <div
            class="person-img"
            @click="personInfo(item)"
            v-for="(item, index) in memberList"
            :key="index"
          >
            <!-- <img
              v-if="item.extend.fileInfo != null"
              :src="item.extend.fileInfo.path || errorImg"
            /> -->
            <img :src="getTearcherImg(item)" @error="headError" />
            <div class="img-name">{{ item.name }}</div>
          </div>
        </div>
        <div
          v-if="memberList.length == 0"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <img src="../../assets/img/emptybox.svg" />
          <div style="margin-top: 4px">暂无内容</div>
        </div>
      </div>
    </div>
    <div class="page d-flex fs-md">
      <div class="pageNum">{{ total }}</div>
      条记录 共
      <div class="pageNum">{{ pageNum }}</div>
      页 当前第
      <div class="pageNum">{{ currPage }}</div>
      页
      <button
        class="port-btn"
        :class="{ 'default-btn': currPage == 1 }"
        @click="changeToFirst()"
      >
        首页
      </button>
      <button
        class="changpage-btn"
        :class="{ 'default-btn': currPage == 1 }"
        @click="changeToPrev()"
      >
        上一页
      </button>
      <button
        class="changpage-btn"
        :class="{ 'default-btn': currPage == pageNum }"
        @click="changeToNext()"
      >
        下一页
      </button>
      <button
        class="port-btn"
        :class="{ 'default-btn': currPage == pageNum }"
        @click="changeToLast()"
      >
        末页
      </button>
    </div>
  </div>
</template>
<script>
import { getTeachers, getLeaders, getProfessor } from '@/api/api'
export default {
  props: [
    'asideTitle',
    'title',
    'currPrograma',
    'currPath',
    'listIndex',
    'listChildIndex',
  ],
  data() {
    return {
      total: 0,
      pageNum: 0,
      currPage: 1,
      limitNum: 12,
      memberList: [],
      personData: [
        { filed: '姓名', value: '王某某' },
        {
          filed: '主要工作',
          value:
            '主要工作的内容主要工作的内容主要工作的内容主要工作的内容主要工作的内容',
        },
        { filed: '联系电话', value: '0571-123456789' },
        { filed: '电子邮箱', value: 'abcde@qq.com' },
        { filed: '办公地点', value: 'xx校区 xx楼 xx层 xxx号办公室' },
      ],
      //   errorImg: require('@/assets/img/default.png'),
    }
  },
  created() {
    this.getMember()
  },
  computed: {
    getTearcherImg() {
      return function (item) {
        if (item.extend.fileInfo == null) {
          if (item.gender == '女') {
            return require('@/assets/img/default2.png')
          } else {
            return require('@/assets/img/default.png')
          }
        } else {
          return item.extend.fileInfo.path
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/default.png')
    },
    getMember() {
      if (this.title == '教师信息') {
        getTeachers(this.currPage, this.limitNum).then((res) => {
          if (res.data.statusCode == 1) {
            this.memberList = res.data.obj.data
            this.total = res.data.obj.count
            this.pageNum = Math.ceil(this.total / this.limitNum)
            // this.total = res.data.obj.count
          }
        })
      } else if (this.title == '部门领导') {
        getLeaders(this.currPage, this.limitNum).then((res) => {
          if (res.data.statusCode == 1) {
            this.memberList = res.data.obj.data
            this.total = res.data.obj.count
            this.pageNum = Math.ceil(this.total / this.limitNum)
          }
        })
      } else if (this.title == '教授引领') {
        getProfessor(this.currPage, this.limitNum).then((res) => {
          if (res.data.statusCode == 1) {
            this.memberList = res.data.obj.data
            this.total = res.data.obj.count
            this.pageNum = Math.ceil(this.total / this.limitNum)
          }
        })
      }
    },
    personInfo(item) {
      this.$router.push({
        path: '/teacher',
        query: {
          one: this.asideTitle,
          two: this.title,
          three: this.currPrograma,
          path: this.currPath,
          keepalive: this.listIndex,
          keepchild: this.listChildIndex,
          teacherId: item.id,
        },
      })
    },
    changeToFirst() {
      this.currPage = 1
      this.getMember()
    },
    changeToPrev() {
      if (this.currPage > 1) {
        this.currPage -= 1
        this.getMember()
      }
    },
    changeToNext() {
      if (this.currPage < Math.ceil(this.total / this.limitNum)) {
        this.currPage += 1
        this.getMember()
      }
    },
    changeToLast() {
      this.currPage = Math.ceil(this.total / this.limitNum)
      this.getMember()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
table,
table tr th,
table tr td {
  border: 1px solid #d1d1d1;
}
table {
  border-collapse: collapse;
  padding: 2px;
}
.td-1 {
  width: 88px;
  height: 36px;
  text-align: center;
  background-color: #e8e8e8;
}
.td-2 {
  width: 432px;
  height: 20px;
  padding: 8px 16px;
}
.article-block {
  width: 692px;
  min-height: 610px;
  background-color: #fff;
  padding: 24px 64px;
}
.module {
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.person-info {
  width: 520px;
}
.letter {
  margin-top: 10px;
}
.person {
  //   margin-top: 10px;
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.person-img {
  //   margin-left: 24px;
  width: 150px;
  height: 200px;
  margin-top: 10px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    object-fit: cover;
    // left: 0;
  }
  .img-name {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: rgba(24, 24, 24, 0.5);
    position: absolute;
    color: #fff;
    font-size: 15px;
    left: 0;
    bottom: 0;
  }
}
.page {
  color: #2f2f2f;
  align-items: center;
  margin-left: 52px;
  padding-bottom: 32px;
}
.pageNum {
  color: #007a4d;
  padding-left: 5px;
  padding-right: 5px;
}
.page {
  button {
    margin-left: 14px;
    border: none;
    font-size: 13px;
    border-radius: 2px;
    padding: 2px 4px;
    color: #fff;
  }
}
.port-btn {
  width: 34px;
  height: 21px;
  background: #66af94;
  cursor: pointer;
}
.changpage-btn {
  width: 47px;
  height: 21px;
  background: #007a4d;
  cursor: pointer;
}
.default-btn {
  background: #d1d1d1 !important;
}
</style>
